import { isDefined } from "@clipboard-health/util-ts";
import { Box, Skeleton, Stack, type SxProps, type Theme } from "@mui/material";

import { mergeSxProps } from "../../lib/mergeSxProps";
import { IconButton } from "../IconButton";
import { Text } from "../Text";

export interface PageHeaderTopRowProps {
  rightAction?: React.ReactNode;
  title?: string | React.ReactNode;
  hideBackButton?: boolean;
  isLoading?: boolean;
  onClickBack?: () => void;
  sx?: SxProps<Theme>;
  navigateBack: () => void | Promise<void>;
  LinkComponent: React.ElementType;
}

export function PageHeaderTopRow(props: PageHeaderTopRowProps) {
  const {
    title,
    isLoading,
    onClickBack,
    rightAction,
    sx,
    hideBackButton = false,
    navigateBack,
    LinkComponent,
  } = props;

  return (
    <Stack
      direction="row"
      sx={mergeSxProps(
        {
          alignItems: "center",
          justifyContent: "space-between",
          px: 5,
          pt: 3,
          pb: 5,
          columnGap: 3,
          rowGap: 5,
        },
        sx
      )}
    >
      <Box sx={{ flexGrow: 1, flexBasis: 0, alignSelf: "flex-start" }}>
        {!hideBackButton && (
          <IconButton
            LinkComponent={LinkComponent}
            iconType="chevron-left"
            variant="outlined"
            size="medium"
            aria-label="Go back"
            onClick={() => {
              if (isDefined(onClickBack)) {
                onClickBack();
              } else {
                void navigateBack();
              }
            }}
          />
        )}
      </Box>

      {isDefined(title) && typeof title === "string" && (
        <Text semibold variant="h6" align="center" sx={{ textWrap: "balance", flexGrow: 1 }}>
          {title}
        </Text>
      )}

      {isDefined(title) && typeof title !== "string" && title}

      {isLoading && !isDefined(title) && (
        <Stack flex={1} height={(theme) => theme.spacing(8)}>
          <Skeleton variant="text" height="100%" />
        </Stack>
      )}

      <Stack
        direction="row"
        sx={{
          flexGrow: 1,
          flexBasis: 0,
          justifyContent: "flex-end",
        }}
      >
        {rightAction}
      </Stack>
    </Stack>
  );
}
